module.exports = "/_next/static/images/buyers_9_ru-dd6054fc05bfbd57169c298ea8ad3d80.png";